/* esm.sh - applesauce-content@5.0.0/text */
export * from "/*applesauce-content@5.0.0/esnext/text.mjs";
